module.exports = __parcel__import__.meta.resolve("l5Cdp");